module.exports = __webpack_public_path__ + "img/reedem-success.787a0d6d.svg";